"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUI = void 0;

var react_1 = __importStar(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

var slate_1 = require("slate");

var slate_react_1 = require("slate-react");

var core_1 = require("@bodiless/core");

var defaultUI = {
  Menu: 'div'
};

exports.getUI = function (ui) {
  if (ui === void 0) {
    ui = {};
  }

  return __assign(__assign({}, defaultUI), ui);
};
/**
 * Update the menu's absolute position.
 */


function updateMenu(menu, editor) {
  var selection = editor.selection;

  if (!menu) {
    return;
  }

  if (!selection || !slate_react_1.ReactEditor.isFocused(editor) || slate_1.Range.isCollapsed(selection) || slate_1.Editor.string(editor, selection) === '') {
    menu.removeAttribute('style');
    return;
  }

  var domSelection = window.getSelection();
  if (!domSelection) return;
  var domRange = domSelection.getRangeAt(0);
  var rect = domRange.getBoundingClientRect();
  var offsetLeft = rect.left + window.pageXOffset - menu.offsetWidth / 2 + rect.width / 2;
  var style = menu.style;
  style.opacity = '1';
  style.visibility = 'visible';
  style.top = rect.top + window.pageYOffset - menu.offsetHeight + "px";
  style.left = (offsetLeft < 0 ? 15 : offsetLeft) + "px";
}

var HoverMenu = function HoverMenu(props) {
  var isEditMode = core_1.useEditContext().isEdit || null;
  var ui = props.ui;
  var Menu = exports.getUI(ui).Menu;

  var children = props.children,
      className = props.className,
      rest = __rest(props, ["children", "className"]);

  var root = typeof window !== 'undefined' ? window.document.body : null;
  var elementID = "hover-menu-" + Math.random().toString(16).slice(2);
  var editor = slate_react_1.useSlate();
  react_1.useEffect(function () {
    var element = document.getElementById(elementID);
    updateMenu(element, editor);
    return function () {};
  });
  return root && isEditMode && react_dom_1.default.createPortal(react_1.default.createElement(Menu, __assign({}, rest, {
    id: elementID,
    className: className
  }), children), root);
};

HoverMenu.displayName = 'HoverMenu';
exports.default = HoverMenu;